import { ModuleConfig, config } from "/@/cool";
import { useStore } from "../base/store";
import { App } from "vue";
export default (): ModuleConfig => {
	return {
		async onLoad() {
			const { user, app, product } = useStore();

			// token 事件
			async function hasToken(cb: () => Promise<any> | void) {
				if (cb) {
					app.addEvent("hasToken", cb);

					if (user.token) {
						await cb();
					}
				}
			}

			await hasToken(async () => {
				await product.loadBuyTypeCateList();
			});

			return {
				hasToken
			};
		}
	};
};
